export default __webpack_public_path__ + "static/media/banner11.959442c2.JPG";